import React from "react";

const StoreCredit = () => {
  return (
    <div className="text-[18px] text-gray-500 italic">
      There are no recent store credit transactions.
    </div>
  );
};

export default StoreCredit;
